import BacnetObjects from '../../../base/menu/airdome/BacnetObjects';

const bacnetObjects: BacnetObjects = {
  categoryName: 'Bacnet Objects',
  view: 'View',
  edit: 'Edit'
};

export default bacnetObjects;
